module.exports = __webpack_public_path__ + "static/media/quotes-icon.efcff728.png";